import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAgenciesWithPrimary extends Layout {
    agencyLinkTable: Table;
    labelResponsibilityUsers: Label;
    sourceAgencyLink: DataSource;
}
